import { isString } from 'shared/lib/type-guards';

import { CampaignStatus, CampaignTypes, CampaignTypesTable, type CampaignTypeKey } from './model';

export const getCampaignTypeName = (value: CampaignTypeKey) => {
  if (!isCampaignType(value)) {
    throw new Error('Unexpected campaign type');
  }

  return CampaignTypes[value];
};

export const getCampaignTypeTableName = (value: CampaignTypeKey) => {
  if (!isCampaignType(value)) {
    throw new Error('Unexpected campaign type');
  }

  return CampaignTypesTable[value];
};

export const isCampaignType = (value: unknown): value is CampaignTypeKey => {
  return isString(value) && value in CampaignTypes;
};

export const isCampaignStatus = (value: unknown): value is CampaignStatus => {
  return isString(value) && value in CampaignStatus;
};
